// extracted by mini-css-extract-plugin
module.exports = {"gridFooter":"footer_gridFooter__ftk5A"};